import { useMemo, useState } from "react"

import { DefaultPopover, Button, Input } from "twyne-new.ui"

import { useCustomUtilities } from "../tailwindConfig/hooks"

const AddPopover = ({ editing, onSubmit, trigger, utility: utilityProps }) => {
  const [open, setOpen] = useState(false)
  const [utility, setUtility] = useState(utilityProps)
  const { value: customUtilities } = useCustomUtilities()

  const [invalidUtility, setInvalidUtility] = useState(false)

  const handleChangeUtility = value => {
    setUtility(value.replace(/[ ]/g, ''))
    setInvalidUtility(false)
  }

  const handleSubmit = () => {
    if (!isValidUtility(utility)) {
      return setInvalidUtility(true)
    }
    onSubmit(utility)
    setOpen(false)
    setUtility()
  }

  const nameAlreadyExists = useMemo(() => utility && customUtilities.includes(utility), [utility, customUtilities])

  return <>
    <DefaultPopover
      trigger={trigger}
      triggerProps={{ asChild: true }}
      contentProps={{ side: 'bottom', align: 'center', onInteractOutside: () => setOpen(false) }}
      wrapperProps={{ open: open, onOpenChange: setOpen }}
    >
      <div className='flex flex-col gap-2'>
        <Input
          value={utility}
          onChange={e => handleChangeUtility(e.target.value)}
          placeholder='Utility name'
          onKeyDown={e => e.key === 'Enter' && handleSubmit()}
        />
        <ErrorMessage message='This utility name already exists' show={nameAlreadyExists} />
        <ErrorMessage message='Invalid utility name' show={invalidUtility} />

        <div className='flex gap-2'>
          <Button disabled={!utility || nameAlreadyExists || invalidUtility} block size='sm' color='accent' onClick={handleSubmit}>
            {editing ? 'Update' : 'Add'}
          </Button>
          <Button block variant='outline' size='sm' onClick={() => setOpen(false)}>
            Cancel
          </Button>
        </div>
      </div>
    </DefaultPopover>
  </>
}

const ErrorMessage = ({ message, show }) => <span className={`twy-text-danger ${show ? 'block' : 'hidden'}`}>{message}</span>

function isValidUtility(utility) {
  if (VALID_PREFIXES.some(p => utility.startsWith(p))) {
    return true
  }

  return false
}

const VALID_PREFIXES = ['[', 'group-', 'peer-', 'has-', 'not-', 'in-', 'nth-', 'nth-last-', 'nth-of-type-', 'nth-last-of-type-', 'min-', 'max-', 'aria-', 'data-']

export default AddPopover
